import emailjs from 'emailjs-com';
import React, { useRef } from 'react';
import { FaTelegramPlane } from 'react-icons/fa';
import { GrStatusGood } from 'react-icons/gr';
import { HiOutlineMail } from 'react-icons/hi';
import './contact.css';
// import { ImWhatsapp } from 'react-icons/im';
const Contact = () => {
  const Send = () => {
    document.querySelector('.iconSend').classList.add('send');
  };
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs.sendForm(
      'service_hgj1lse',
      'template_cmstz17',
      form.current,
      'MVtG6Bp5zUisuJpvr'
    );
    e.target.reset();
    Send();
  };
  return (
    <section id="contact">
      <h5 className="text-light">Get In Touch</h5>
      <h5 className="text-light">
        I do receive your messages and will respond asap if the valid email is
        provided
      </h5>
      <h2>Contact Me</h2>
      <div className="container contact-container">
        <div className="contact-options">
          <article className="contact-option">
            <HiOutlineMail className="contact-icon" />
            <h4>Email</h4>
            <h5 className="text-light">ao.yacine47@gmail.com</h5>
            <a href="mailto:ao.yacine47@gmail.com" target="_blank">
              Send a message
            </a>
          </article>
          <article className="contact-option">
            <FaTelegramPlane className="contact-icon" />
            <h4>Telegram</h4>
            <h5 className="text-light">Yacine Aoumara</h5>
            <a href="https://t.me/AoumaraYacine/start" target="_blank">
              Send a message
            </a>
          </article>
          
        </div>
        {/* <form ref={form} onSubmit={sendEmail}>
          <input
            type="text"
            name="name"
            placeholder="Your Full Name"
            required
          />
          <input type="email" name="email" placeholder="Your Email" required />
          <textarea
            name="message"
            rows="4"
            placeholder="Your Message"
            required
          ></textarea>
          <button type="submit" className="btn btn-primary">
            Send Massage <GrStatusGood className="iconSend" />
          </button>
        </form> */}
      </div>
    </section>
  );
};

export default Contact;
